import React, { useState } from 'react';
import {
    Box,
    Button,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel
} from '@mui/material';
import RootDialogPage from '../../Commun/components/RootDialogPage';
import { useLanguage } from '../../Commun/contexts/LanguageContext';
import { blobticMessage } from '../../Commun/components/BlobticMessage';
import { projectsApi } from '../services/projectsApi';

interface ProjectCreateDialogProps {
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
    customers: any[];
}

export const ProjectCreateDialog: React.FC<ProjectCreateDialogProps> = ({
    open,
    onClose,
    onSuccess,
    customers
}) => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        customerId: '',
    });
    const [loading, setLoading] = useState(false);
    const { t } = useLanguage();
    

    const handleCreateProject = async () => {
        try {
            setLoading(true);
            await projectsApi.create({
                name: formData.name,
                description: formData.description || undefined,
                customerId: parseInt(formData.customerId),
            });
            blobticMessage.success(t('common.messages.success'), t('maker.msg.success.create'));
            onSuccess();
            onClose();
            setFormData({ name: '', description: '', customerId: '' });
        } catch (error: any) {
            console.error('Error creating project:', error);
            blobticMessage.error(t('common.messages.error'), t('maker.msg.error.create'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <RootDialogPage
            open={open}
            onClose={onClose}
            title={t('maker.projects.new')}
            onAction={handleCreateProject}
            actionLabel={t('action.create')}
            actionDisabled={loading || !formData.name || !formData.customerId}
            maxWidth="sm"
            fullWidth
        >
            <Box component="form" sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                    label={t('maker.field.name')}
                    required
                    fullWidth
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />
                <TextField
                    label={t('maker.field.description')}
                    fullWidth
                    multiline
                    rows={3}
                    value={formData.description}
                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                />
                <FormControl fullWidth required>
                    <InputLabel>{t('maker.field.customer')}</InputLabel>
                    <Select
                        value={formData.customerId}
                        label={t('maker.field.customer')}
                        onChange={(e) => setFormData({ ...formData, customerId: e.target.value })}
                    >
                        {customers.map((customer) => (
                            <MenuItem key={customer.id} value={customer.id}>
                                {customer.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
        </RootDialogPage>
    );
};
